import CopyValue from "../../CopyValue/CopyValue";
import { useOrganizations } from "../../../contexts/UserProvider";
import { useTranslations } from "../../../contexts/Translation";
import { InfoMessage } from "../../InfoMessage/InfoMessage";
import { Tip } from "../../../components/Tip/Index";
import Collapsable from "@/components/Collapsable/Collapsable";
import Card from "@/components/Card/Card";
import styles from "./InviteSection.module.css";
import { selfUrl } from "../../../lib/runtimeConfig";

const InviteSection = () => {
  const { currentOrganization } = useOrganizations();
  const t = useTranslations("userManagementForm");

  return (
    <div className={styles.section}>
      <Card className={styles.card} padding='none' variant='collapsable'>
        <Collapsable toggleItem={t("inviteUsersTitle")} closed={false}>
          <Tip>{t("inviteUsersDescription")}</Tip>
          <CopyValue value={`${selfUrl()}/join?org=${currentOrganization}`} />
          <InfoMessage type='warning'>{t("inviteUsersInfo")}</InfoMessage>
        </Collapsable>
      </Card>
    </div>
  );
};

export default InviteSection;
